import { render, staticRenderFns } from "./AdministratorDetail.vue?vue&type=template&id=672735b6&scoped=true&"
import script from "./AdministratorDetail.vue?vue&type=script&lang=js&"
export * from "./AdministratorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672735b6",
  null
  
)

export default component.exports